import { IntegrationType } from '@accedo/one-plugin-sdk';
import { useMemo } from 'react';

import { useConfig } from '#/hooks/useConfig';
import { getPluginConfigs } from '#/plugins/hooks/utils';
import { FeatureConfig } from '#/service/config/features.types';
import { useBootStore } from '#/store/boot/boot.store';

export const useFirstPluginConfig = (type: IntegrationType) => {
  const { isPluginManagerReady } = useBootStore();
  const config = useConfig();

  const integration: FeatureConfig<any> | undefined = useMemo(() => {
    if (!isPluginManagerReady) {
      return;
    }

    return getPluginConfigs(config, type).first;
  }, [config, isPluginManagerReady, type]);

  return integration;
};
